(function () {
  "use strict";

  var isEN = window.Shopify && Shopify.locale === "en";
  var rootUrl = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/";

  var B2B_PAGE = rootUrl + "pages/espace-professionnels";
  var CONTACT_PAGE = rootUrl + "pages/contact";

  function t(fr, en) { return isEN ? en : fr; }

  function renderHeaderChip() {
    var target =
      document.querySelector(".header-toolbar .toolbar") ||
      document.querySelector(".header-toolbar") ||
      document.querySelector("header .header");
    if (!target || document.querySelector("[data-oi-b2b-header]")) return;

    var link = document.createElement("a");
    link.href = B2B_PAGE;
    link.className = "oi-b2b-chip";
    link.setAttribute("data-oi-b2b-header", "");
    link.textContent = t("Espace Pros", "Pro Space");
    target.appendChild(link);
  }

  function renderFooterCard() {
    var container =
      document.querySelector(".section-footer .additional-footer") ||
      document.querySelector(".section-footer");
    if (!container || document.querySelector("[data-oi-b2b-footer]")) return;

    var box = document.createElement("div");
    box.className = "oi-b2b-footer";
    box.setAttribute("data-oi-b2b-footer", "");
    box.innerHTML =
      "<p><strong>" + t("Professionnels :", "Professionals:") + "</strong> " +
      t("h\u00f4tels, restaurants, bureaux, architectes.", "hotels, restaurants, offices, architects.") + "</p>" +
      '<p><a href="' + B2B_PAGE + '">' + t("Demander un devis B2B", "Request a B2B quote") + "</a></p>";
    container.appendChild(box);
  }

  function renderPdpBlock() {
    if (!document.body.classList.contains("theme-template-product")) return;
    if (document.querySelector("[data-oi-b2b-pdp]")) return;

    var anchors = [
      ".x-block-buy-buttons",
      '[id^="ProductInfo-"]',
      ".parent-element.product-info",
      "form[action*='/cart/add']"
    ];

    var target = null;
    for (var i = 0; i < anchors.length; i++) {
      target = document.querySelector(anchors[i]);
      if (target) break;
    }
    if (!target) return;

    var block = document.createElement("div");
    block.className = "oi-b2b-pdp";
    block.setAttribute("data-oi-b2b-pdp", "");
    block.innerHTML =
      '<p class="oi-b2b-pdp__title">' + t("Projet sur mesure (B2B)", "Custom project (B2B)") + "</p>" +
      '<p class="oi-b2b-pdp__text">' + t(
        "Dimensions, tissu, ignifuge, quantit\u00e9 et d\u00e9lai : configurez votre besoin professionnel.",
        "Dimensions, fabric, fire-retardant, quantity and lead time: configure your professional needs."
      ) + "</p>" +
      '<div class="oi-b2b-pdp__line">' +
      '<input type="text" placeholder="' + t("Dimensions (ex: L140 x H260 cm)", "Dimensions (e.g. W140 x H260 cm)") + '">' +
      '<input type="text" placeholder="' + t("Tissu / finition", "Fabric / finish") + '">' +
      "</div>" +
      '<div class="oi-b2b-pdp__line">' +
      '<input type="text" placeholder="' + t("Quantit\u00e9 totale", "Total quantity") + '">' +
      '<input type="text" placeholder="' + t("D\u00e9lai souhait\u00e9", "Desired lead time") + '">' +
      "</div>" +
      '<div class="oi-b2b-pdp__usage"><select>' +
      "<option>" + t("Usage pro rapide", "Quick professional use") + "</option>" +
      "<option>" + t("H\u00f4tel", "Hotel") + "</option>" +
      "<option>" + t("Restauration", "Restaurant") + "</option>" +
      "<option>" + t("Bureau", "Office") + "</option>" +
      "<option>" + t("Location courte dur\u00e9e", "Short-term rental") + "</option>" +
      "</select></div>" +
      '<table class="oi-b2b-pdp__pricing"><thead><tr><th>Volume</th><th>' + t("Remise indicative", "Indicative discount") + "</th></tr></thead><tbody>" +
      "<tr><td>" + t("10+ unit\u00e9s", "10+ units") + "</td><td>-8%</td></tr>" +
      "<tr><td>" + t("30+ unit\u00e9s", "30+ units") + "</td><td>-15%</td></tr>" +
      "<tr><td>" + t("100+ unit\u00e9s", "100+ units") + "</td><td>-22%</td></tr></tbody></table>" +
      '<div class="oi-b2b-pdp__chips">' +
      '<span class="oi-b2b-pdp__chip">' + t("Norme M1/ignifuge : sur demande", "M1/fire-retardant: on request") + "</span>" +
      '<span class="oi-b2b-pdp__chip">' + t("Entretien : fiche fournie", "Care: sheet provided") + "</span>" +
      '<span class="oi-b2b-pdp__chip">' + t("MOQ : selon r\u00e9f\u00e9rence", "MOQ: per reference") + "</span>" +
      '<span class="oi-b2b-pdp__chip">' + t("Personnalisation : oui", "Customization: yes") + "</span></div>" +
      '<div class="oi-b2b-pdp__actions"><a class="oi-b2b-btn oi-b2b-btn--primary" href="' + B2B_PAGE + '">' + t("Demander un devis pro", "Request a pro quote") + "</a> " +
      '<a class="oi-b2b-btn oi-b2b-btn--secondary" href="' + CONTACT_PAGE + '">' + t("Commander des \u00e9chantillons", "Order samples") + "</a></div>";

    target.parentNode.insertBefore(block, target);
  }

  function renderHomeBlock() {
    if (!document.body.classList.contains("theme-template-index")) return;
    if (document.querySelector("[data-oi-b2b-home]")) return;

    var main = document.querySelector("#MainContent");
    if (!main) return;

    var wrap = document.createElement("section");
    wrap.className = "oi-b2b-home";
    wrap.setAttribute("data-oi-b2b-home", "");
    wrap.innerHTML =
      '<div class="oi-b2b-home__inner">' +
      '<div><h2 class="oi-b2b-home__title">' + t("Espace Professionnels", "Professional Space") + "</h2>" +
      '<p class="oi-b2b-home__text">' + t(
        "H\u00f4tellerie, restauration, bureaux, architectes : chiffrage rapide et solutions sur mesure.",
        "Hotels, restaurants, offices, architects: quick quotes and made-to-measure solutions."
      ) + "</p></div>" +
      '<div class="oi-b2b-home__actions">' +
      '<a class="oi-b2b-btn oi-b2b-btn--primary" href="' + B2B_PAGE + '">' + t("Demander un devis", "Request a quote") + "</a>" +
      '<a class="oi-b2b-btn oi-b2b-btn--secondary" href="' + B2B_PAGE + '">' + t("Ouvrir un compte pro", "Open a pro account") + "</a>" +
      "</div></div>";

    main.insertBefore(wrap, main.firstChild);
  }

  function renderStickyBar() {
    if (document.querySelector("[data-oi-b2b-sticky]")) return;
    var bar = document.createElement("div");
    bar.className = "oi-b2b-sticky";
    bar.setAttribute("data-oi-b2b-sticky", "");
    bar.innerHTML =
      "<p>" + t("Besoin d'un chiffrage en 24h ?", "Need a quote within 24h?") + "</p>" +
      '<a class="oi-b2b-btn oi-b2b-btn--primary" href="' + B2B_PAGE + '">' + t("Demander un devis", "Request a quote") + "</a>";
    document.body.appendChild(bar);
  }

  var b2bTranslations = {
    "Hotel 4* - Renovation de 84 chambres": "4-Star Hotel - Renovation of 84 Rooms",
    "Programme de renovation complete avec planning par etage.": "Complete renovation program with floor-by-floor planning.",
    "Hotellerie": "Hospitality",
    "Moderniser les chambres avec occultation efficace et rendu premium.": "Modernize rooms with effective blackout and premium finish.",
    "Rideaux occultants sur mesure + voilage grande hauteur coordonne.": "Custom blackout curtains + coordinated tall sheer curtains.",
    "Chambres plus confortables, meilleure experience client et mise en service dans les delais.": "More comfortable rooms, better guest experience and on-time delivery.",
    "Restaurant haut de gamme - Ambiance de salle": "Upscale Restaurant - Dining Room Ambiance",
    "Refonte textile de la salle principale pour service midi et soir.": "Textile redesign of the main dining room for lunch and dinner service.",
    "Restauration": "Restaurant / Dining",
    "Filtrer la lumiere et renforcer l\u2019ambiance sans assombrir la salle.": "Filter light and enhance the ambiance without darkening the room.",
    "Filtrer la lumiere et renforcer l'ambiance sans assombrir la salle.": "Filter light and enhance the ambiance without darkening the room.",
    "Voilages sur mesure et finitions adaptees au concept decoratif.": "Custom sheer curtains and finishes adapted to the decorative concept.",
    "Salle plus douce, plus elegante et plus confortable pour les clients.": "A softer, more elegant and comfortable room for guests.",
    "Bureaux & coworking - Open space premium": "Offices & Coworking - Premium Open Space",
    "Projet multi-zones sur open space, salles de reunion et accueil.": "Multi-zone project for open space, meeting rooms and reception.",
    "Bureaux & coworking": "Offices & Coworking",
    "Mieux gerer la lumiere naturelle et renforcer l\u2019image des espaces.": "Better manage natural light and enhance the image of spaces.",
    "Mieux gerer la lumiere naturelle et renforcer l'image des espaces.": "Better manage natural light and enhance the image of spaces.",
    "Habillage de fenetres adapte aux usages des espaces de travail.": "Window dressing adapted to workspace usage.",
    "Confort visuel ameliore et rendu plus coherent pour les equipes comme pour les visiteurs.": "Improved visual comfort and a more consistent look for teams and visitors.",
    "Direction d exploitation - Hotel partenaire": "Operations Director - Partner Hotel",
    "Projet bien cadre, livraison dans les delais et rendu final tres qualitatif. Equipe reactive du debut a la fin.": "Well-managed project, on-time delivery and very high-quality final result. Responsive team from start to finish.",
    "Gerance - Restaurant independant": "Management - Independent Restaurant",
    "Nous avions une vraie contrainte d\u2019ambiance et de luminosite. La solution proposee s\u2019integre parfaitement a notre salle.": "We had a real constraint on ambiance and lighting. The proposed solution fits perfectly into our dining room.",
    "Nous avions une vraie contrainte d'ambiance et de luminosite. La solution proposee s'integre parfaitement a notre salle.": "We had a real constraint on ambiance and lighting. The proposed solution fits perfectly into our dining room.",
    "Office manager - Bureaux tertiaires": "Office Manager - Commercial Offices",
    "Equipe serieuse, a l\u2019ecoute, avec un accompagnement fluide sur le choix des tissus, dimensions et finitions.": "Serious team, attentive, with smooth guidance on fabric choice, dimensions and finishes.",
    "Equipe serieuse, a l'ecoute, avec un accompagnement fluide sur le choix des tissus, dimensions et finitions.": "Serious team, attentive, with smooth guidance on fabric choice, dimensions and finishes.",
    "Architectes & decorateurs": "Architects & Decorators",
    "Chambres, suites, lobby, petit-dejeuner et espaces communs.": "Rooms, suites, lobby, breakfast and common areas.",
    "Salles, vitrines, lounge, ambiance lumineuse et finition deco.": "Dining rooms, showcases, lounge, lighting ambiance and decorative finishes.",
    "Open spaces, salles de reunion, accueil et espaces de direction.": "Open spaces, meeting rooms, reception and management areas.",
    "Accompagnement projet, rendu premium et sur mesure adapte au site.": "Project support, premium finish and custom solutions adapted to the site.",
    "Projet sur mesure": "Custom project",
    "Hotellerie\nProjet sur mesure\nOccultation": "Hospitality\nCustom project\nBlackout",
    "Restaurant\nVoilage\nAmbiance": "Restaurant\nSheer curtains\nAmbiance",
    "Bureaux\nConfort visuel\nImage pro": "Offices\nVisual comfort\nPro image"
  };

  function translateB2BPage() {
    if (!isEN) return;
    var container = document.querySelector(".oi-b2b-page");
    if (!container) return;

    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue.trim();
      if (text && b2bTranslations[text]) {
        node.nodeValue = node.nodeValue.replace(text, b2bTranslations[text]);
      }
    }
  }

  function init() {
    renderHeaderChip();
    renderFooterCard();
    renderPdpBlock();
    renderHomeBlock();
    renderStickyBar();
    translateB2BPage();
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("oi:wishlist:updated", init);
})();
